<template>
  <el-dialog
    :visible.sync="visibility"
    :before-close="fechar"
    width="50%"
    v-loading="loading"
    append-to-body
    title="Desfazer troca de Titularidade"
  >
   <div>
    <table class="tabela-detalhes-clientes" style="font-size: 10px; padding: 0px 15px;">
      <thead>
        <th scope="col" style="text-align: left;">Proprietário</th>
        <th scope="col" style="text-align: left;">Participação no Imóvel</th>
      </thead>

      <tbody>
        <tr v-for="(proprietario, index) in listaProprietarios" :key="index">
          <td>{{ proprietario.nome }}</td>
          <td>
            <el-input-number v-model="proprietario.perfis[0].participacaoImovel"
              size="small"
              :precision="2"
              :step="5.0"
              :min="0"
              :max="maxPara(index)"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>

    <span slot="footer">
      <el-button @click="desfazerRemocaoProprietarioHandler()" round class="btn-box-shadow" type="success" size="small" icon="el-icon-check">
        Confirmar
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    visibility: Boolean,
    historico: Object,
    proprietarios: Array
  },

  data() {
    return {
     listaProprietarios: []
    }
  },

  watch: {
    visibility(val) {
      if(val) {
        if(this.historico.acao === 'REMOCAO') {
          this.listaProprietarios = [
            ...this.proprietarios.map(proprietario => ({ ...proprietario })),
            { ...this.clienteAnterior, perfis: [{ participacaoImovel: 0 }] }
          ]
        } else {
          this.listaProprietarios = [
            ...this.proprietarios.filter(item => item.id !== this.historico.clienteAnterior.id).map(proprietario => ({ ...proprietario }))
          ]
        }
      }
    }
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },

    clienteAnterior() {
      return this.historico.clienteAnterior
    },

    totalParticipacaoProprietariosRestantes() {
      return this.listaProprietarios.reduce((soma, proprietario) => soma + proprietario.perfis[0].participacaoImovel, 0);
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisContratosStore', [
      'desfazerRemocaoProprietario',
      'desfazerAdicaoProprietario'
    ]),
    maxPara(index) {
      const somaOutros = this.totalParticipacaoProprietariosRestantes - this.listaProprietarios[index].perfis[0].participacaoImovel;

      return 100 - somaOutros;
    },

    fechar() {
      this.$emit('close');
    },

    desfazerRemocaoProprietarioHandler() {
      if(this.totalParticipacaoProprietariosRestantes < 100) {
        this.$message.warning('O valor da soma das participações deve ser igual a 100');
        return;
      }

      const payload = this.historico.acao === 'REMOCAO' ? this.montarPayloadDesfazerRemocao() : this.montarPayloadDesfazerAdicao() ;

      this.showLoading();

      if(this.historico.acao === null || this.historico.acao === 'REMOCAO') {
        this.desfazerRemocaoProprietario(payload)
        .then(resposta => {
          switch (resposta.status) {
            case "SUCESSO":
              this.$message.success(resposta.mensagem);
              break;
            case "FALHA":
              this.$message.warning(resposta.mensagem);
              break;
            case "ERRO":
              this.$message.error(resposta.mensagem);
              break;
          }
        }).catch(() => {
          this.$message.error('Erro ao comunicar-se com o servidor.')
        }).finally(() => {
          this.fechar();
          this.hideLoading();
        })
      } else {
        this.desfazerAdicaoProprietario(payload)
          .then(resposta => {
            switch (resposta.status) {
              case "SUCESSO":
                this.$message.success(resposta.mensagem);
                break;
              case "FALHA":
                this.$message.warning(resposta.mensagem);
                break;
              case "ERRO":
                this.$message.error(resposta.mensagem);
                break;
            }
          }).catch(() => {
            this.$message.error('Erro ao comunicar-se com o servidor.')
          }).finally(() => {
            this.fechar();
            this.hideLoading();
          })
        }
    },

    montarPayloadDesfazerRemocao() {
      return {
        ...this.historico,
        proprietarios: this.listaProprietarios.map(item => ({ ...item, isSelecionadoParaTroca: undefined }))
      }
    },

    montarPayloadDesfazerAdicao() {
      return {
        ...this.historico,
        proprietarios: this.listaProprietarios.filter(item => item.id !== this.historico.clienteAnterior.id).map(item => ({ ...item, isSelecionadoParaTroca: undefined }))
      }
    }
  }
}
</script>